import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25C12.6904 3.25 13.25 3.80964 13.25 4.5V10.75H19.5C20.1904 10.75 20.75 11.3096 20.75 12C20.75 12.6904 20.1904 13.25 19.5 13.25H13.25V19.5C13.25 20.1904 12.6904 20.75 12 20.75C11.3096 20.75 10.75 20.1904 10.75 19.5V13.25H4.5C3.80964 13.25 3.25 12.6904 3.25 12C3.25 11.3096 3.80964 10.75 4.5 10.75H10.75V4.5C10.75 3.80964 11.3096 3.25 12 3.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
